export { useCardHeaderBase_unstable as useCardHeader } from '@fluentui/react-card';
